// extracted by mini-css-extract-plugin
export default {"container":"close_container__2tI6Z","bar":"close_bar__QQXUE","first":"close_first__A0D_K","last":"close_last__OrvFa"};